import { render, staticRenderFns } from "./BannerBankAccount.vue?vue&type=template&id=7d71b818&scoped=true&"
import script from "./BannerBankAccount.vue?vue&type=script&lang=ts&"
export * from "./BannerBankAccount.vue?vue&type=script&lang=ts&"
import style0 from "./BannerBankAccount.vue?vue&type=style&index=0&id=7d71b818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d71b818",
  null
  
)

export default component.exports